/**
 * 合同模块共用的字典与展示方法
 */

/** 合同类型：1框架协议2销售合同3代理协议4服务合同 */
export const CONTRACT_TYPE_MAP = {
  1: "框架协议",
  2: "销售合同",
  3: "代理协议",
  4: "服务合同",
};

/** 合同状态（按 100 倍数递增）：0草稿 100执行中 200已完成 300已逾期 */
export const CONTRACT_STATUS_MAP = {
  0: {text: "草稿", type: "info"},
  100: {text: "执行中", type: "primary"},
  200: {text: "已完成", type: "success"},
  300: {text: "已逾期", type: "danger"},
};

export function contractTypeName(value) {
  return CONTRACT_TYPE_MAP[value] || "—";
}

export function contractStatusOf(value) {
  return CONTRACT_STATUS_MAP[value] || {text: "—", type: "info"};
}
